const KEY = 'gf_printer_mode_cache';

export const getPrinterMode = (printerId) => {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const map = JSON.parse(raw);
    return map[printerId] || null;
};

export const setPrinterMode = (printerId, mode) => {
    const raw = sessionStorage.getItem(KEY);
    const map = raw ? JSON.parse(raw) : {};
    map[printerId] = mode;
    sessionStorage.setItem(KEY, JSON.stringify(map));
};
